<template>
	<v-card
		ref="property-card"
		class="property-card"
		elevation="10"
		@click="goToPropertyDetail(property.property_title, property.id)"
	>
		<v-row no-gutters>
			<v-col
				v-resize="onResize"
				cols="12"
			>
				<div class="property-img">
					<span
						v-if="property.type_property === 'จองแล้ว'"
						class="property-reserved"
					>
						<img
							:src="`/images/2.0/reserved${propertyReserved}.png`"
							alt="reserved label"
							width="95"
						>
					</span>
					<z-img
						:storage="property.mainImage"
						:alt="property.property_title"
						max-width="100%"
						:max-height="maxHeight"
					/>
					<div class="property-location d-flex">
						<div class="text-truncate flex-grow-1 pr-3">
							<v-icon class="red--text">
								mdi-map-marker
							</v-icon>
							{{ property.locationText }}
						</div>
						<div class="flex-shrink-0">
							<v-icon class="red--text">
								mdi-clock
							</v-icon>
							{{ timeAgo(property.updated_at) }}
						</div>
					</div>
				</div>
			</v-col>
			<v-col
				cols="12"
				class="property-info pa-3"
			>
				<div class="property-code red--text">
					รหัส {{ `T-${property.id}` }}
				</div>
				<div class="property-title">
					<n-link
						:to="$routerHelper.getPathByRouteName('property-detail', { title: (property.property_title || ''), id: property.id })"
						:title="property.property_title"
					>
						{{ property.property_title }}
					</n-link>
				</div>
				<v-row class="property-spec grey--text mt-2 px-3">
					<v-col cols="6">
						<img
							src="/images/2.0/icon/property-card/ic_area_bk.png"
							alt="area icon"
						>
						{{ `${property.space_1 || 0}-${property.space_2 || 0}-${property.space_3 || 0}` }}
					</v-col>
					<v-col cols="6">
						<img
							src="/images/2.0/icon/property-card/ic_area-use_bk.png"
							alt="usable area icon"
						>
						{{ property.area || '-' }}
					</v-col>
				</v-row>
				<v-row class="property-spec grey--text mt-2 px-3">
					<v-col cols="3">
						<img
							src="/images/2.0/icon/property-card/ic_layers_bk.png"
							alt="floor icon"
						>
						{{ property.high_floor || '-' }}
					</v-col>
					<v-col cols="3">
						<img
							src="/images/2.0/icon/property-card/ic_sofa_bk.png"
							alt="bedroom icon"
						>
						{{ property.bedroom || '-' }}
					</v-col>
					<v-col cols="3">
						<img
							src="/images/2.0/icon/property-card/ic_shower_bk.png"
							alt="bathroom icon"
						>
						{{ property.bathroom || '-' }}
					</v-col>
					<v-col cols="3">
						<img
							src="/images/2.0/icon/property-card/ic_car_bk.png"
							alt="car park icon"
						>
						{{ property.car_park || '-' }}
					</v-col>
				</v-row>

				<!-- <div class="property-spec d-flex grey--text mt-2">
					<div class="d-flex align-content-center">
						<v-icon class="red--text mt-n2">
							mdi-move-resize
						</v-icon>
						{{ `${property.space_1 || 0}-${property.space_2 || 0}-${property.space_3 || 0}` }}
					</div>
					<div class="pl-6">
						<v-icon class="red--text">
							mdi-select-group
						</v-icon>
						{{ property.area || '-' }}
					</div>
				</div>
				<div class="d-flex grey--text">
					<div>
						<v-icon class="red--text">
							mdi-layers-triple
						</v-icon>
						{{ property.high_floor || '-' }}
					</div>
					<div class="pl-6">
						<v-icon class="red--text">
							mdi-sofa-single
						</v-icon>
						{{ property.bedroom || '-' }}
					</div>
					<div class="pl-6">
						<v-icon class="red--text">
							mdi-bathtub
						</v-icon>
						{{ property.bathroom || '-' }}
					</div>
					<div class="pl-6">
						<v-icon class="red--text">
							mdi-car
						</v-icon>
						{{ property.car_park || '-' }}
					</div>
				</div> -->
			</v-col>
		</v-row>
		<div class="bgGrey d-flex align-end px-3 py-2">
			<span>{{ property.type_action === 'เช่า' ? 'เช่า' : 'ราคา' }}</span>
			<span class="property-price mx-auto red--text">
				{{ numberFormat(property.type_action === 'เช่า' ? property.rental_price : property.sale_price) }}
			</span>
			<v-icon
				aria-label="Mark as favorite property"
				style="color: #c20000 !important;"
				class="mb-1"
				@click.stop.prevent="addOrRemoveFavorite(property.id)"
			>
				mdi-heart{{ isFavorite(property.id) ? '' : '-outline' }}
			</v-icon>
		</div>
	</v-card>
</template>

<script>

import { mapActions, mapGetters } from 'vuex'

export default {
	props: {
		id: {
			type: Number,
			default: null
		},
		showAll: {
			type: Boolean,
			default: true
		}
	},
	data:() => ({
		property: null,
		image: [],
		aspectRatio: undefined,
		maxHeight: '100%'
	}),
	computed: {
		...mapGetters({
			getLocation: 'getLocation',
			getProperty: 'property/getProperty',
			isFavorite: 'property/isFavorite',
		}),

		propertyReserved () {
			if (this.property) {
				if (!this.property.sales || this.property.sales.length === 0) {
					return ''
				} else if (this.property.sales.findIndex(i => i.sale_contract === 'ล็อคสิทธิ์') === -1) {
					return '-nolock'
				}
				return '-lock'
			}
			return ''
		}
	},
	watch: {
		// xs () {
		// 	this.onResize()
		// }
	},
	created() {
		this.property = this.getProperty(this.id)
	},
	methods: {
		...mapActions({
			addOrRemoveFavorite: 'property/addOrRemoveFavorite'
		}),
		onResize () {
			if (process.client) {
				// this.maxHeight = this.$refs['property-card'].$el.clientWidth * 0.78
				// this.maxHeight = window.innerWidth > 959 ? '225' : (window.innerWidth > 599 ? '244' : '100%')
				// this.maxHeight = window.innerWidth > 1264 ? '182' : (window.innerWidth > 959 ? '166' : '100%')
				// this.aspectRatio = window.innerWidth > 959 ? undefined : '4/3'
			}
		},
		goToPropertyDetail(title, id) {
			this.$router.push(this.$routerHelper.getPathByRouteName('property-detail', { title: (title || ''), id: id }))
		}
	},
}
</script>

<style lang="scss" scoped>
.property-card {
	cursor: pointer;
	font-size: 0.9rem;

	.property-img::v-deep {
		position: relative;

		.v-responsive__sizer {
			padding-bottom: 78% !important;
		}
		.property-reserved {
			position: absolute;
			z-index: 2;
			opacity: 0.9;
		}
		.property-location {
			position: absolute;
			left: 0;
			bottom: 0;
			right: 0;
			padding: 10px;
			color: #fff;
			background: rgb(103,103,103);
			background: linear-gradient(180deg, rgba(103, 103, 103, 0.05) 0%, rgba(103, 103, 103, 0.35) 10%, rgba(83, 83, 83, 0.65) 30%, rgba(32, 32, 32, 0.85) 100%);
		}
	}

	.property-info {
		box-sizing: border-box;

		.red--text {
			color: #b11112 !important;
		}
		.property-code {
			font-size: 0.85rem;
			font-weight: bold;
		}
		.property-title {
			height: 65px;
			display: -webkit-box;
			-webkit-box-orient: vertical;
			-webkit-line-clamp: 3;
			overflow: hidden;

			a {
				text-decoration: none;
				font-weight: bold;
				color: #000;
			}
		}
		.property-spec {
			& > .col {
				padding: 0;
				display: flex;
				align-items: center;
			}

			img {
				width: 1rem;
				margin-right: 5px;
			}
		}
	}
	.property-price {
		font-size: 1rem;
		font-weight: bold;
	}

	.property-price.red--text {
		color: #9B0D0D !important;
	}
	.grey--text {
		color: #595959 !important;
	}

	.v-icon {
		font-size: 1.1rem;
	}
}

.bgGrey {
	background-color: #e9e9e9;
}

div.text-truncate {
	// display: -webkit-box;
	// -webkit-line-clamp: 2;
	// -webkit-box-orient: vertical;
	// white-space: normal !important;
}
</style>
